import useOpenApiCall from "hooks/useOpenApiCall";

const { apiCall } = useOpenApiCall();

export const fetchFooterData = () =>
  apiCall({ url: "https://assets.airtel.in/static-assets/cms/b2b/b2b-widgets/json/b2b-footer-data-minified.json" })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
